import React from 'react';
import './LaptopsImage.css';
import LaptopsImg from './assets/laptops-image.webp';

function LaptopsImage(){
    return(
        <div className='laptops-image'>
            <img src={LaptopsImg} alt='Laptops Image' className='fluid-image'/>
        </div>
    )
}

export default LaptopsImage;